import React, { useState, useEffect } from 'react';
import moment from 'moment';
import LoadingSpinner from '$app/shared/components/LoadingSpinner';
import { api } from '$app/api';
import DriversAllocation from '.';
import { getBookingsToAllocateToDrivers } from './apis/bookings';

const DriversAllocationWrapper = () => {
  const [garages, setGarages] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [bookings, setBookings] = useState(null);

  const getAllGarages = () => api.get(`/garages`);
  const getAllDrivers = () => api.get(`/drivers?all=true`);

  useEffect(() => {
    getAllGarages().then(({ data }) => {
      setGarages(data.garages);
    });

    getAllDrivers().then(({ data }) => {
      setDrivers(data);
    });
  }, []);

  const earliestBookingDate = moment().subtract(60, 'day').startOf('day').format();
  useEffect(() => {
    getBookingsToAllocateToDrivers(earliestBookingDate).then(setBookings).catch(console.error);
  }, [earliestBookingDate]);

  if (!garages || !bookings) return <LoadingSpinner />;

  return (
    <DriversAllocation
      bookings={bookings}
      garages={garages}
      drivers={drivers}
      earliestBookingDate={earliestBookingDate}
    />
  );
};

export default DriversAllocationWrapper;
